const NAME = 'customImageTypes';

export default {
  NAME,
};
